export default __webpack_public_path__ + "static/media/lock.066095ee.svg";